import { Skeleton, Stack, Typography } from '@mui/material';

function HeadlessNotificationSkeleton() {
  return (
    <Stack
      paddingX={2.5 + 1}
      paddingY={2.5 + 0.75}
      direction="row"
      alignItems="start"
      justifyContent="start"
      flexWrap="nowrap"
      position="relative"
    >
      <Skeleton variant="circular" width={40} height={40} sx={{ marginRight: 2, flexShrink: 0 }} />
      <Stack position="absolute" top={26} right={20}>
        <Skeleton variant="circular" width={8} height={8} />
      </Stack>
      <Stack
        direction="column"
        alignItems="start"
        justifyContent="start"
        gap={0.5}
        paddingRight={1.5}
        textAlign="left"
        sx={{ flexGrow: 1 }}
      >
        <Typography variant="subtitle2" width="100%">
          <Skeleton variant="text" width="100%" />
        </Typography>
        <Typography variant="subtitle2" width="100%">
          <Skeleton variant="text" width="100%" />
        </Typography>
        <Typography variant="body2" width="100%">
          <Skeleton variant="text" width="100%" />
        </Typography>
        <Typography variant="caption" color="text.secondary" width="100%">
          <Skeleton variant="text" width="100%" />
        </Typography>
      </Stack>
    </Stack>
  );
}

export default HeadlessNotificationSkeleton;
